import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Navigation, Keyboard, Mousewheel } from 'swiper/modules'
import gsap from 'gsap'

import 'swiper/css' //eslint-disable-line
import 'swiper/css/navigation' //eslint-disable-line

export default class extends BaseModule {
  init() {
    const slider = this.el
    const { sliderConfig } = slider.dataset

    const params = {
      fragments: {
        modules: [Navigation, Keyboard, Mousewheel],
        draggable: true,
        slidesPerView: 'auto',
        grabCursor: true,
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
        mousewheel: true,
        keyboard: {
          enabled: true,
        },
      },
    }

    this.swiper = new Swiper(slider, params[sliderConfig])
    gsap.to(slider, {
      opacity: 1,
      duration: 2,
      ease: 'power2.Out',
    })
  }
}
